<template>
  <div>
    <router-view v-slot="{ Component }">
      <transition name="el-zoom-in-center" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
    <!-- <transition name="el-zoom-in-center">
      <router-view />
    </transition> -->
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
</style>
